import React, {  useState } from 'react';
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard React components
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import Grid from "@mui/material/Grid";

import IconFilterAlt from '@mui/icons-material/FilterAlt';
import IconRefresh from "@mui/icons-material/RefreshOutlined";
import IconContentPasteGo from "@mui/icons-material/ContentPasteGo";
import IconArticleIcon from '@mui/icons-material/Article';

import Swal from 'sweetalert2';
import { Card } from '@mui/material';
import { useEffect } from 'react';

import Ordenes from 'Repository/Ordenes';

const initialValues = {
    fechaaltaantesde: '',
    fechaaltadespuesde: ''
}

 export const Filtro = ({ onApliyFilter }) => {

    const [inputValues, setInputValues] = useState(initialValues);
    const ordenesx = new Ordenes();
    //#region events

        const onInputChange = ({target}) =>{
            setInputValues({
                ...inputValues,
                [target.name]: target.value
            })
        }

        const resetForm = () =>{
            setInputValues(initialValues)
            onApliyFilter(initialValues);
        }

        const onExport = ()=>{
            ordenesx.exportarOperaciones(inputValues);
        }

        useEffect(()=>{
            currentDate();
        }, [])

    //#endregion

    //#region methods
    const currentDate = async ()=>{
       const data = await ordenesx.consultarFechas();
       setInputValues({
        ...inputValues,
        fechaaltaantesde: data.response.data.antesde,
        fechaaltadespuesde: data.response.data.despuesde,
       });
    }
    //#endregion

    return (
        <>
          
                <SoftBox pl={1} pt={2} pb={3} component="form" role="form" bgColor="color12" borderRadius="lg"  >
                    <Grid container spacing={2} >

                        <Grid item xs={3} md={2} xl={2}>
                            <SoftBox mb={1} lineHeight={0}>
                                <SoftTypography variant="caption" color="color18" >
                                    Desde
                                </SoftTypography>
                            </SoftBox>
                            <SoftBox>
                                <SoftInput type="date" placeholder="" name="fechaaltadespuesde"
                                value = { inputValues.fechaaltadespuesde }
                                autoComplete="off" onChange={ (event)=>onInputChange(event) }
                                />
                            </SoftBox>
                        </Grid>

                        <Grid item xs={3} md={2} xl={2}>
                            <SoftBox mb={1} lineHeight={0}>
                                <SoftTypography variant="caption"  color="color18" >
                                    Hasta
                                </SoftTypography>
                            </SoftBox>
                            <SoftBox>
                                <SoftInput type="date" placeholder=""  name="fechaaltaantesde"
                                value = { inputValues.fechaaltaantesde } onChange={ (event)=>onInputChange(event) }
                                autoComplete="off"
                                />
                            </SoftBox>
                        </Grid>
                            
                        <Grid item xs={2} md={2} xl={2}>
                            <SoftBox pt={3} >
                                <SoftButton fullWidth  color="color5V"  onClick={ (event) => onApliyFilter(inputValues) } >
                                    <IconFilterAlt /> Filtrar
                                </SoftButton>
                            </SoftBox>
                        </Grid>
                        <Grid item xs={2} md={2} xl={2}>
                            <SoftBox pt={3} >
                                <SoftButton fullWidth  color="color6A"  onClick={ resetForm  } >
                                    <IconRefresh /> Quitar filtro
                                </SoftButton>
                            </SoftBox>
                        </Grid>
                        <Grid item xs={2} md={1} xl={1}>
                            <SoftBox pt={3} >
                                <SoftButton fullWidth  color="color6V"  onClick={ onExport  } >
                                    <IconArticleIcon />
                                </SoftButton>
                            </SoftBox>
                        </Grid>
                        
                        
                    </Grid>
                </SoftBox>

           
        </>
    )
}

Filtro.propTypes = {
    onApliyFilter: PropTypes.func
};

export default Filtro;